import { forwardRef } from "react";

const InputField = forwardRef(({ 
  icon: Icon, 
  type = "text", 
  placeholder, 
  value, 
  onChange, 
  required = false,
  readOnly = false,
  disabled = false,
  rightIcon: RightIcon,
  onRightIconClick,
  className = ""
}, ref) => {
  return (
    <div className="relative">
      {Icon && <Icon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />}
      <input
        ref={ref}
        type={type}
        required={required}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        disabled={disabled}
        className={`w-full ${Icon ? 'pl-9' : 'pl-3'} ${RightIcon ? 'pr-10' : 'pr-3'} py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none transition-all text-sm [&::-ms-reveal]:hidden [&::-ms-clear]:hidden ${className}`}
      />
      {RightIcon && (
        <button
          type="button"
          onClick={onRightIconClick}
          disabled={disabled}
          tabIndex={-1}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none cursor-pointer p-0.5"
        >
          <RightIcon className="w-4 h-4" />
        </button>
      )}
    </div>
  );
});

InputField.displayName = "InputField";

export default InputField;
